import React from 'react';

const CommentsListItemHeader = ({
  author, deleteConfirmation, deleteConfirmationOpened, time, optionsMenu,
  optionsMenuOpened, owned, toggleMenu
}) => (
  <div className="header flex justify-between items-start">
    <p className="f--2 f--1-ns t-mv0 fw4 lh-title">{author}</p>
    <div className="flex items-center justify-end relative">
      <span className="silver t-mt0 f--3 tr lh-solid t-pr2" >{time}</span>
      {owned &&
        <img
          src="/images/webreader/ic-more.svg"
          className="dib pointer"
          width="15"
          height="16"
          alt=""
          onClick={toggleMenu}
        />
      }
      { optionsMenuOpened && optionsMenu }
      { deleteConfirmationOpened && deleteConfirmation }
    </div>
  </div>
);

CommentsListItemHeader.defaultProps = {
  author: 'defaultAuthor',
  deleteConfirmationOpened: false,
  time: 'Jan 1, 2017 0:00',
  optionsMenuOpened: false,
  owned: false,
  toggleMenu: null,
  deleteConfirmation: 'deleteConfirmation',
  optionsMenu: 'optionsMenu'
};

export default CommentsListItemHeader;
